export enum FileFilterOption {
  All = 'all',
  Files = 'files',
  Images = 'images',
}
